
import Vue from 'vue'

import convertCase from '@/mixins/convert-case'
import isRole from '@/mixins/crud/computed/isRole'
import { arenaHasShopV1History } from '@/utils/shopV1'

export default Vue.extend({
  props: ['drawer', 'loggedIn'],

  mixins: [convertCase, isRole],

  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
    localDrawer: false,
    activeGroup: '',
  }),

  computed: {
    country() {
      return this.$store.getters.country
    },

    hasShopV1History() {
      const arena = this.$store.getters.arena
      return arenaHasShopV1History(arena ? arena.id : null)
    },

    navItems() {
      // Initialize routes available for everyone
      const mainRoutes = [
        {
          icon: 'mdi-account-details',
          key: 'employeeDashboard',
          route: '/employee-dashboard',
        },
        {
          icon: 'games',
          key: 'playingNow',
          route: '/playing-now',
        },
        {
          icon: 'mdi-gamepad-square',
          key: 'sessions',
          route: '/sessions',
        },
      ]

      const userRoutes = [
        {
          icon: 'people',
          key: 'users',
          route: '/users',
        },
      ]

      const shopV2Routes = [
        {
          icon: 'mdi-cash',
          key: 'purchase',
          route: '/purchase',
        },
        {
          icon: 'mdi-shape-outline',
          key: 'products',
          route: '/products',
        },
        {
          icon: 'receipt',
          key: 'invoices',
          route: '/invoices',
        },
        ...(this.hasShopV1History
          ? [
              {
                icon: 'receipt',
                key: 'invoicesV1',
                route: '/invoices-v1',
              },
            ]
          : []),
        ...(this.country !== 'ba'
          ? [
              {
                icon: 'mdi-sale',
                key: 'promotions',
                route: '/promotions',
              },
            ]
          : []),
        {
          icon: 'mdi-transfer',
          key: 'stockTransactions',
          route: '/stock-transactions',
        },
        {
          icon: 'settings',
          key: 'settings',
          route: '/shop-settings',
        },
      ]

      // Push sort order for admins & managers
      if (this.isManager || this.isAdmin) {
        shopV2Routes.splice(shopV2Routes.length - 1, 0, {
          icon: 'mdi-sort-numeric-ascending',
          key: 'sortOrder',
          route: '/sort-order',
        })
      }

      // Push user coin history for admins only
      if (this.isAdmin) {
        userRoutes.push({
          icon: 'mdi-history',
          key: 'coinHistory',
          route: '/coin-history',
        })
      }

      const configurationRoutes = [
        {
          icon: 'games',
          key: 'games',
          route: '/games',
        },
        {
          icon: 'apps',
          key: 'apps',
          route: '/apps',
        },
        {
          icon: 'mdi-account-key',
          key: 'sharedAccounts',
          route: '/shared-accounts',
        },
      ]

      const socialRoutes = [
        {
          icon: 'mdi-post',
          key: 'articles',
          route: '/articles',
        },
        {
          icon: 'event',
          key: 'events',
          route: '/events',
        },
      ]

      // Add admin dashboard & mobile notifications only for admins & managers
      if (this.isAdmin || this.isManager) {
        mainRoutes.unshift({
          icon: 'dashboard',
          key: 'adminDashboard',
          route: '/admin-dashboard',
        })
        configurationRoutes.push({
          icon: 'mdi-sale',
          key: 'maxBonuses',
          route: '/max-bonuses',
        })
        socialRoutes.push({
          icon: 'mdi-bell',
          key: 'mobileNotifications',
          route: '/mobile-notifications',
        })
      }

      const grouped = [
        {
          key: 'main',
          icon: 'house',
          items: mainRoutes,
        },
        {
          key: 'users',
          icon: 'people',
          items: userRoutes,
        },
        {
          key: 'shopV2',
          icon: 'attach_money',
          items: shopV2Routes,
        },
        {
          key: 'newsManager',
          icon: 'library_books',
          items: socialRoutes,
        },
        {
          key: 'finance',
          icon: 'mdi-finance',
          route: '/finance',
        },
        {
          key: 'configuration',
          icon: 'settings',
          items: configurationRoutes,
        },
      ]

      // Add setup for admins
      if (this.isAdmin) {
        grouped.push({
          key: 'setup',
          icon: 'mdi-database-settings',
          items: [
            {
              icon: 'location_on',
              key: 'arenas',
              route: '/arenas',
            },
            {
              icon: 'assured_workload',
              key: 'taxJurisdictions',
              route: '/tax-jurisdictions',
            },
          ],
        })
      }

      return grouped
    },

    arenaId() {
      return this.$store.getters.arena ? `/${this.$store.getters.arena.id}` : ''
    },
  },

  watch: {
    $route: function (to) {
      this.setGroup(to.path)
    },
    drawer: function () {
      this.localDrawer = this.drawer
    },
    localDrawer: function () {
      this.$emit('update:drawer', this.localDrawer)
    },
  },

  mounted() {
    this.setGroup(this.$route.path)
  },

  methods: {
    setGroup(path = '') {
      if (this.arenaId.length) {
        path = path.replace(this.arenaId, '')
      }
      for (const navItem of this.navItems) {
        // Skip standalone items (they don't have a group to activate)
        if (!navItem.items) continue
        for (const item of navItem.items) {
          if (item.route === path) {
            this.activeGroup = navItem.key
            return
          }
        }
      }
    },
  },
})
